import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';

import { WhatsappService } from './../../services/whatsapp.service';
import { ConversacionCalidadService } from './../../services/conversacion-calidad.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-modal-conversacion',
  templateUrl: './modal-conversacion.page.html',
  styleUrls: ['./modal-conversacion.page.scss'],
})
export class ModalConversacionPage implements OnInit {
  @Input() conversacion: any;
  @Input() agente: string;
  @Input() nombreCliente: string;
  @Input() cliente: string;
  chat: any;
  classUser: any;
  loading: any;

  evaluacion: any[] = [];
  totalPuntos = 0;
  estructuraEvaluacion = '';
  valorSeccionPrincipal: any;

  infoInsuficiente = false;
  soloEnlaces = false;

  canal: any;
  canales: any;
  canalInicial: any;
  idAdmin: number;

  constructor(
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private loadingController: LoadingController,
    private serviceWa: WhatsappService,
    private calidadService: ConversacionCalidadService,
    private storage: Storage
  ) { 
    this.canales = [];
  }

  ngOnInit() {
    this.presentLoading('Analizando Conversación');
    this.chat = [];
      this.getCanal();
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canales = await this.storage.get('canales').then();
      // console.log(this.canales, 'canales ');
      this.canalInicial = this.canales.find(canal => canal.canale.idAdmin_sec == this.canal.idAdmin_sec);
      this.idAdmin = this.canalInicial.canale.idAdmin_sec;
      this.classUser = this.canalInicial;
      this.getChat();
  }

  getChat() {
    const query = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_admin: this.conversacion.id_admin,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_cliente: this.conversacion.id_cliente,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      id_agente: this.conversacion.id_agente,
      conversacion: this.conversacion.conversacion
    };

    this.serviceWa.getChat(query, this.classUser.id, this.classUser.rol, this.classUser.token, this.classUser.canale.url_back)
      .subscribe((res: any) => {
        const { status, message } = res;
        if (status === 'success') {
          const { chats } = res;
          this.chat = chats;

          let conver = '';
          // eslint-disable-next-line @typescript-eslint/prefer-for-of
          for (let index = 0; index < this.chat.length; index++) {
            const mensajeActual = this.chat[index].mensaje.trim();
            if (this.chat[index].autor === 'cliente') {
              conver += `paciente: ${mensajeActual} `;
              // eslint-disable-next-line max-len
            } else if (this.chat[index].autor === 'agente' || this.chat[index].autor === 'supervisor' || this.chat[index].autor === 'admin') {
              conver += `agente: ${mensajeActual} `;
            }
          }

          // Verificar si la conversación está vacía
          if (!conver || conver.trim() === '') {
            this.infoInsuficiente = true;
            this.loading.dismiss();
            return;
          }

          // Verificar si la longitud de la conversación es menor a 90 caracteres
          if (conver.length < 90) {
            this.infoInsuficiente = true;
            this.loading.dismiss();
            return;
          }

          console.log('Conversación:\n', conver);
          this.conversacionCalidad(conver);
        }
        else {
          this.loading.dismiss();
        }
      },
        erro => {
          console.log(erro);
          this.loading.dismiss();
        });
  }

  conversacionCalidad(conversacion) {
    this.calidadService.getCalidad(conversacion).subscribe(
      (res: any) => {
        console.log(res);
        const { status, response } = res;

        if (status === 'success' && response?.kwargs?.content) {
          this.estructuraEvaluacion = response.kwargs.content;
          console.log('Estructura de la Evaluacion:\n', this.estructuraEvaluacion);

          if (this.estructuraEvaluacion.toLowerCase().includes('enlace') || this.estructuraEvaluacion.toLowerCase().includes('audio')) {
            this.soloEnlaces = true;
            this.loading.dismiss();
            return;
          }

          this.procesarEstructura();
        } else {
          this.infoInsuficiente = true;
        }
        this.loading.dismiss();
      },
      erro => {
        console.log(erro);
        this.loading.dismiss();
      });
  }

  // procesarEstructura() {
  //   const lines = this.estructuraEvaluacion.split('\n'); //\n\n
  //   let currentField = '';
  //   let currentMetrics = [];
  //   let subtotal = 0;
  //   this.totalPuntos = 0;

  //   lines.forEach(line => {
  //     line = line.trim();

  //     // Detectar una nueva sección principal
  //     if (this.esSeccionPrincipal(line)) {
  //       // Si existe una sección previa, la guardamos en la evaluación final
  //       if (currentField) {
  //         this.evaluacion.push({
  //           campo: currentField,
  //           metricas: currentMetrics,
  //           subtotal: (subtotal === 0) ? subtotal.toFixed(0) : subtotal.toFixed(3)
  //         });
  //         this.totalPuntos += subtotal;

  //         if (this.totalPuntos === 0) {
  //           this.infoInsuficiente = true;
  //           this.loading.dismiss();
  //           return;
  //         }
  //       }

  //       // Reiniciar valores para la nueva sección
  //       currentField = this.extraerNombreSeccion(line);
  //       currentMetrics = [];
  //       subtotal = this.extraerValorDirectoSeccion(line); // Extraemos el valor si está en el formato "*Sección: X puntos"

  //       // Detectar submétricas
  //     } else if (this.esSubmetrica(line)) {
  //       const metricData = this.procesarSubmetrica(line);
  //       currentMetrics.push(metricData);
  //       subtotal += parseFloat(metricData.valor);
  //     }
  //   });

  //   // Procesar última sección, si existe
  //   if (currentField) {
  //     this.evaluacion.push({
  //       campo: currentField,
  //       metricas: currentMetrics,
  //       subtotal: (subtotal === 0) ? subtotal.toFixed(0) : subtotal.toFixed(3)
  //     });
  //     this.totalPuntos += subtotal;

  //     if (this.totalPuntos === 0) {
  //       this.infoInsuficiente = true;
  //       this.loading.dismiss();
  //       return;
  //     }
  //   }
  // }

  procesarEstructura() {
    // Dividir por \n para procesar cada línea
    const lines = this.estructuraEvaluacion.split('\n');

    this.evaluacion = [];
    const processedLines: string[] = [];

    lines.forEach(line => {
      line = line.trim();

      // Si es una línea de total general, ignorarla, pero capturar los puntos
      if (/^Total\s*([\d.]+)\s*puntos/.test(line)) {
        const totalMatch = line.match(/Total\s*([\d.]+)\s*puntos/);
        this.totalPuntos = totalMatch ? parseFloat(totalMatch[1]) : 0;
        return; // No incluir esta línea en el HTML ni en los procesados
      }

      // Remover el asterisco inicial, si existe
      if (line.startsWith('*')) {
        line = line.substring(1).trim();
      }

      // Agregar la línea procesada a la lista
      processedLines.push(line);
    });

    // Reconstruir el texto procesado con \n y asignarlo a estructuraEvaluacion
    this.estructuraEvaluacion = processedLines.join('\n');

    // Si no se encontró un total, mostrar como insuficiente
    if (this.totalPuntos === 0) {
      this.infoInsuficiente = true;
      this.loading.dismiss();
      return;
    }
  }

  // esSeccionPrincipal(line) {
  //   return (
  //     line.startsWith('*') &&
  //     (line.includes('(total') && line.includes('puntos)') ||
  //       line.includes(':') && line.includes('puntos'))
  //   );
  // }

  // extraerNombreSeccion(line) {
  //   if (line.includes('(total')) {
  //     return line.slice(1, line.indexOf('(total')).trim();
  //   } else if (line.includes(':')) {
  //     return line.slice(1, line.indexOf(':')).trim();
  //   }
  //   return '';
  // }

  // extraerValorSeccionPrincipal(line) {
  //   const match = line.match(/\(total\s*([\d.]+)\s*puntos\)/);
  //   return (match ? parseFloat(match[1]) : 0).toFixed(2);
  // }

  // esSubmetrica(line) {
  //   return (
  //     line.startsWith('*') && (line.endsWith('puntos') || line.endsWith('puntos.'))
  //   );
  // }

  // Extrae el valor de la sección directamente si está en el formato "*Sección: X puntos"
  // extraerValorDirectoSeccion(line) {
  //   const match = line.match(/:\s*(\d+(\.\d+)?)/);
  //   return match ? parseFloat(match[1].trim()) : 0;
  // }

  // Procesa submétrica y extrae su valor
  // procesarSubmetrica(line) {
  //   let nombreMetrica = '';
  //   let valor = 0;

  //   if (line.includes(', vale')) {
  //     const metricParts = line.split(', vale');
  //     nombreMetrica = metricParts[0].slice(1).trim();
  //     valor = parseFloat(metricParts[1].replace(/[^0-9.]/g, '').trim());
  //   } else {
  //     const metricParts = line.split(/[:()]/);
  //     nombreMetrica = metricParts[0].slice(1).trim();
  //     valor = parseFloat(metricParts[1].replace(/[^0-9.]/g, '').trim());
  //   }

  //   return {
  //     nombre: nombreMetrica,
  //     valor: (valor === 0) ? valor.toFixed(0) : valor.toFixed(3),
  //     siNo: valor > 0 ? 'Si' : 'No'
  //   };
  // }

  async closeModal() {
    this.modalCtrl.dismiss();
  }

  async presentToast(message, color) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 3000,
      color
    });
    toast.present();
  }

  async presentLoading(mensaje) {
    this.loading = await this.loadingController.create({
      spinner: 'dots',
      message: mensaje,
    });
    await this.loading.present();
  }
}
